import React from 'react';
import BlockContainer from './BlockContainer';
import { PAGE_1 } from './assets';
import { Link } from 'react-scroll';
import styles from './FrontPage.module.scss';
import { downloadApk } from './Helper';

export default function FrontPage() {
    const [checked1, setChecked1] = React.useState(true);
    const [checked2, setChecked2] = React.useState(true);
    const onTouchDownload = () => {
        downloadApk();
    }
    return (
        <div className={styles["container"]} id="firstPage">
            <BlockContainer />
            <div className={styles["main-container"]} id="frontPage">
                <div className={styles["video-container"]}>
                    <video src="./assets/page_1/frontpage_video.mp4" autoPlay muted loop />
                </div>
                <div className={styles["logo-container"]}>
                    <img src={PAGE_1.LOGO.default} alt="Logo" />
                </div>
                <div className={styles["download-container"]}>
                    <button type="button"  className={`fn-skip-detail` } >
                    <img src={PAGE_1.DOWNLOAD.default}  alt="DMM GAMES"  className={ `${styles["button"]}` }    />
                    {/* <img src={PAGE_1.DOWNLOAD.default}  alt="DMM GAMES" onClick={onTouchDownload} className={ `${styles["button"]}` }    /> */}
                    </button>
                    {/* <img src={PAGE_1.FRAME.default} alt="Frame" className={styles["frame"]} /> */}
                    <div className={`${styles["position-relative"]} ${styles["text-align-center"]}` }>
                        <img src={PAGE_1.BOX2.default} alt="" />
                        <input type="checkbox" id="a1"   defaultChecked={checked1}   className={`${styles["checked-1"]} skipDetail_notification`} />
                        <input type="checkbox" id="a2"   defaultChecked={checked2}   className={`${styles["checked-2"]} skipDetail_myapp`}/>
                    </div>
                </div>
                {/* <div className={styles["reward-container"]}>
                  
                    <img src={PAGE_1.DOWNLOAD2.default} alt="reward" />
                    <div className={styles["position-relative"]}>
                        <img src={PAGE_1.BOX1.default} alt="" />
                        <div className={styles['number-panel']}>
                            <img className={styles['number']} src="./assets/page_1/1.png" alt="" />
                            <img className={styles['number']} src="./assets/page_1/0.png" alt="" />
                        </div>

                    </div>
                    <div className={styles["position-relative"]}>
                        <img src={PAGE_1.BOX2.default} alt="" />
                        <input type="checkbox" className={`${styles["checked-1"]} skipDetail_notification`} />
                        <input type="checkbox" className={`${styles["checked-2"]} skipDetail_myapp`}/>
                    </div>
                </div> */}
                <Link
                    activeClass="active"
                    to="pageTwo"
                    spy={true}
                    smooth={true}
                    duration={1000}
                >
                    <div className={styles["arrow-container"]}>
                        <img src={PAGE_1.ARROW.default} alt="Arrow" />
                    </div>
                </Link>

            </div>
        </div>
    )
}